export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10477.16779b48.jpg";